var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_9975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C6.977 22 2.5 17.523 2.5 12C2.5 6.477 6.977 2 12.5 2C18.023 2 22.5 6.477 22.5 12C22.5 17.523 18.023 22 12.5 22ZM12.5 20C14.6217 20 16.6566 19.1571 18.1569 17.6569C19.6571 16.1566 20.5 14.1217 20.5 12C20.5 9.87827 19.6571 7.84344 18.1569 6.34315C16.6566 4.84285 14.6217 4 12.5 4C10.3783 4 8.34344 4.84285 6.84315 6.34315C5.34285 7.84344 4.5 9.87827 4.5 12C4.5 14.1217 5.34285 16.1566 6.84315 17.6569C8.34344 19.1571 10.3783 20 12.5 20ZM11.5 15H13.5V17H11.5V15ZM13.5 13.355V14H11.5V12.5C11.5 12.2348 11.6054 11.9804 11.7929 11.7929C11.9804 11.6054 12.2348 11.5 12.5 11.5C12.7841 11.5 13.0623 11.4193 13.3023 11.2673C13.5423 11.1154 13.7343 10.8984 13.8558 10.6416C13.9773 10.3848 14.0234 10.0988 13.9887 9.81684C13.954 9.53489 13.84 9.26858 13.6598 9.04891C13.4797 8.82924 13.2409 8.66523 12.9712 8.57597C12.7015 8.48671 12.412 8.47587 12.1364 8.54471C11.8608 8.61354 11.6104 8.75923 11.4144 8.96482C11.2183 9.1704 11.0847 9.42743 11.029 9.706L9.067 9.313C9.18863 8.70508 9.46951 8.14037 9.88092 7.67659C10.2923 7.2128 10.8195 6.86658 11.4086 6.67332C11.9977 6.48006 12.6275 6.44669 13.2337 6.57661C13.8399 6.70654 14.4007 6.99511 14.8588 7.41282C15.3169 7.83054 15.6559 8.36241 15.8411 8.95406C16.0263 9.54572 16.0511 10.1759 15.9129 10.7803C15.7747 11.3847 15.4785 11.9415 15.0545 12.3939C14.6306 12.8462 14.0941 13.1779 13.5 13.355Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_9975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpcircle);
export default __webpack_public_path__ + "static/media/helpcircle.e61a4c07e55ef10beefc3bee265e2474.svg";
export { ForwardRef as ReactComponent };